import { render, staticRenderFns } from "./EditarDados.vue?vue&type=template&id=5cc92cc4&scoped=true&"
import script from "./EditarDados.vue?vue&type=script&lang=js&"
export * from "./EditarDados.vue?vue&type=script&lang=js&"
import style0 from "./EditarDados.vue?vue&type=style&index=0&id=5cc92cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc92cc4",
  null
  
)

export default component.exports